import contact from "../../../content/contact/contact.json";

export const ContactListLogic = () => {
	return { contact };
};
